import styled from 'styled-components';

export const Wrapper = styled.div`
    margin:0px 40px;
`;